import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function UserIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="UserIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <path
                id="FontAwsome_user_"
                d="M10.768,10.439c-.985,0-1.459.549-3.077.549s-2.088-.549-3.077-.549A4.616,4.616,0,0,0,0,15.053v.879a1.649,1.649,0,0,0,1.648,1.648H13.735a1.649,1.649,0,0,0,1.648-1.648v-.879A4.616,4.616,0,0,0,10.768,10.439ZM7.692,9.889A4.945,4.945,0,1,0,2.747,4.945,4.946,4.946,0,0,0,7.692,9.889Z"
                transform="translate(0.5 0.5)"
                fill="none"
                stroke="#fff"
                strokeWidth="1"
            />
        </SvgIcon>
    );
}
